import React, { useEffect, useState } from 'react';
import { X, Gift, Check } from 'lucide-react';
export function EmailCapturePopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    if (hasShown) return;
    let triggered = false;
    const triggerOpen = () => {
      if (triggered) return;
      triggered = true;
      setIsOpen(true);
      setHasShown(true);
    };
    const handleScroll = () => {
      const scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (scrolled > 0.4) triggerOpen();
    };
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY < 10) triggerOpen();
    };
    const timer = setTimeout(triggerOpen, 45000);
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mouseleave', handleMouseLeave);
      clearTimeout(timer);
    };
  }, [hasShown]);
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && email.includes('@')) {
      setSubmitted(true);
      setTimeout(() => setIsOpen(false), 3000);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-in fade-in duration-200" onClick={() => setIsOpen(false)} role="dialog" aria-modal="true" data-id="element-195">
      <div className="bg-[#FBF7F0] rounded-2xl max-w-md w-full shadow-2xl relative overflow-hidden border-4 border-[#C2410C]" onClick={e => e.stopPropagation()} data-id="element-196">
        <button onClick={() => setIsOpen(false)} aria-label="Close" className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/80 flex items-center justify-center text-[#3E2723] hover:bg-white z-10" data-id="element-197">
          <X className="w-4 h-4" data-id="element-198" />
        </button>

        {!submitted ? <div className="p-8 text-center" data-id="element-199">
            <div className="w-16 h-16 mx-auto bg-[#C2410C] rounded-full flex items-center justify-center mb-4 shadow-lg" data-id="element-200">
              <Gift className="w-8 h-8 text-white" data-id="element-201" />
            </div>
            <div className="inline-block bg-yellow-300 text-[#3E2723] text-xs font-extrabold px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-202">
              Free Gift Inside
            </div>
            <h3 className="text-3xl text-[#3E2723] mb-3 leading-tight" data-id="element-203">
              Wait! Don't Leave Empty-Handed
            </h3>
            <p className="text-[#3E2723]/80 mb-6 leading-relaxed" data-id="element-204">
              Drop your email and we'll send you{' '}
              <strong className="text-[#C2410C]" data-id="element-205">3 free resort recipes</strong>{' '}
              from the playbook — including the Oaxacan Mole Negro shortcut.
            </p>
            <form onSubmit={handleSubmit} className="space-y-3" data-id="element-206">
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full px-4 py-3 rounded-lg border-2 border-[#3E2723]/20 focus:border-[#C2410C] focus:outline-none text-[#3E2723] text-base" data-id="element-207" />
              <button type="submit" className="w-full bg-[#C2410C] hover:bg-[#9A3412] text-white py-3.5 rounded-lg font-extrabold text-base uppercase tracking-wide transition-colors shadow-lg" data-id="element-208">
                Send Me the 3 Free Recipes
              </button>
            </form>
            <p className="text-xs text-[#3E2723]/50 mt-4" data-id="element-209">
              No spam. Unsubscribe anytime. We never share your email.
            </p>
          </div> : <div className="p-10 text-center" data-id="element-210">
            <div className="w-16 h-16 mx-auto bg-[#14B8A6] rounded-full flex items-center justify-center mb-4" data-id="element-211">
              <Check className="w-9 h-9 text-white" data-id="element-212" />
            </div>
            <h3 className="text-2xl font-bold text-[#3E2723] mb-2" data-id="element-213">
              Check your inbox!
            </h3>
            <p className="text-[#3E2723]/70" data-id="element-214">
              Your 3 free recipes are on their way. Get ready to taste paradise.
            </p>
          </div>}
      </div>
    </div>;
}